'use strict';

var _ = require('lodash');
var BootstrapService = function BootstrapService($q, bootstrapFeaturesService, staticDataService, hepService, foMarketsService, App, restangular, UserFactory) {
  var optionalCommonDataToLoad = [staticDataService.loadHubs];
  var requiredCommonDataToLoad = [loadVersion, loadUserList, loadNonAdminUserList, hepService.loadSimpleHepProperties, hepService.loadDefaultQueryConfigurations, hepService.loadQueryConfigurations, hepService.loadSystemProperties, hepService.loadDefaultWorkflowSettings, hepService.loadSystemStatusConfig, retrieveTimeZoneData];
  var FeatureToLoadedDataConfig = {
    OPTIONAL: {
      REVENUE_OPTIMIZER: _.concat(optionalCommonDataToLoad, [staticDataService.loadEntities, staticDataService.loadOptimizationRules, hepService.loadHostShare, hepService.loadSpecialEvents, hepService.loadDefaultDaysOffsets]),
      DYNAMIC_AVAILABILITY: optionalCommonDataToLoad
    },
    REQUIRED: {
      REVENUE_OPTIMIZER: _.concat(requiredCommonDataToLoad, [staticDataService.loadMarkets, staticDataService.loadPoses, loadSubsidiaryCarriers, staticDataService.loadSeasons, staticDataService.loadFlightNumbers, staticDataService.loadFlightDowGroups, staticDataService.loadMarketDowGroups, staticDataService.loadOperatingCarriers, staticDataService.loadFlightTags, staticDataService.loadLegs, hepService.loadClassGroupConfig, hepService.loadFcrConfig, hepService.loadROMColorConfiguration]),
      DYNAMIC_AVAILABILITY: _.concat(requiredCommonDataToLoad, [staticDataService.loadFpMarkets, staticDataService.loadFpCabins, staticDataService.loadDaPoses, staticDataService.loadLegs, staticDataService.loadSeasons, hepService.loadAdvancePurchasingDepartureDateRange, hepService.loadFpNesting, hepService.loadFrequencyConfig, hepService.loadAllBenchmarkCarriers, retrieveCountryCodesData]),
      FARES_OPTIMIZER: _.concat(requiredCommonDataToLoad, [loadSubsidiaryCarriers, foMarketsService.loadFoMarkets, hepService.loadFoMaxStayGroups, hepService.loadFoMinStayGroups, hepService.loadFoAdvPurchaseGroups, hepService.loadFoSeasonDefinitions, hepService.loadFoSimpleHepProperties, hepService.loadFoAnalystPosMapping, hepService.loadFoStatusRejectionCode, hepService.loadFoRecommendationLadderStatuses, hepService.loadFoSmoothingMethods, hepService.loadFOCabinClassConfig, hepService.loadFoAirportRegionMapping, hepService.loadFrequencyConfig, hepService.loadFoCurrencies, hepService.loadFoRecommendationReasons, hepService.loadFoFareBrandDefinitions, hepService.loadFOTariffMatrixConfig, hepService.loadFOTariffMatrixProperties, hepService.loadIncludedTariffs]).concat(requiredCommonDataToLoad, [staticDataService.freezeMarketsAndPos()])
    }
  };
  var userConfigRefresh = {
    REVENUE_OPTIMIZER: [loadUserList, loadNonAdminUserList, staticDataService.loadLegs, staticDataService.loadMarkets],
    DYNAMIC_AVAILABILITY: [loadUserList, loadNonAdminUserList, staticDataService.loadFpMarkets, staticDataService.loadFpCabins, staticDataService.loadLegs],
    FARES_OPTIMIZER: [loadUserList, loadNonAdminUserList]
  };
  function callLoadingDataFunctionsForEnabledApps(enabledApps, dataFunctionsCategory) {
    var functionArray = _.chain(enabledApps).flatMap(function (app) {
      return dataFunctionsCategory[app];
    }).uniq().compact().value();
    return callLoadingDataFunctions(functionArray);
  }
  function callLoadingDataFunctions(functionsArray) {
    var promises = [];
    _.forEach(functionsArray, function (func) {
      promises.push(func());
    });
    return promises;
  }
  function loadConfiguration() {
    var enabledApps = bootstrapFeaturesService.getEnabledApps();

    /* optional */
    callLoadingDataFunctionsForEnabledApps(enabledApps, FeatureToLoadedDataConfig.OPTIONAL);

    /* required */
    return addCookie().then(function () {
      return loadUser().then(function () {
        return $q.all(callLoadingDataFunctionsForEnabledApps(enabledApps, FeatureToLoadedDataConfig.REQUIRED));
      });
    });
  }
  function load() {
    return hepService.loadFeatures().then(loadConfiguration);
  }
  function loadUser() {
    return retrieveUserData();
  }
  function retrieveUserData() {
    return $q.all([getSelfData(), getUserPrivileges()]).then(function (response) {
      var userData = response[0].plain();
      var userPrivileges = response[1].plain();
      App.User = _.extend(userData, userPrivileges);
      App.userFactory = new UserFactory(App.User);
      App.userId = userData.userId;
      return isAdminUser(App.User.roles).then(function (isAdminResponse) {
        App.User.isAdmin = isAdminResponse;
        return userData;
      });
    });
  }
  function retrieveTimeZoneData() {
    var dateTimeSettings = _.get(App.User, ['preferences', 'dateTimeNumberFormatSettings'], {});
    var timeZoneSetting = _.find(dateTimeSettings, ['name', 'timeZone']);
    var cityCode = timeZoneSetting ? timeZoneSetting.value : 'UNDEFINED';
    return restangular.one('ancillary').one('city').one('tzOffsets').one(cityCode).get().then(function (data) {
      App.tzOffsets = {
        code: data.code,
        offset: data.offset,
        daylightSavingTimes: data.daylightSavingTimes
      };
    })["catch"](function () {
      App.tzOffsets = undefined;
    });
  }
  function queryForIsAdminCategory(role) {
    var queryParams = {
      type: 'RolesAndPrivileges',
      filter: ['role==\'' + role + '\'', 'roleCategory==Admin'].join(';')
    };
    return restangular.one('configuration').one('hep').one('all').get(queryParams);
  }
  function isAdminUser(roles) {
    function isAdminRole(data) {
      return _.find(data, function (hep) {
        return hep.hepList.length > 0;
      });
    }
    var isAdminDeferred = $q.defer();
    var isAdminQueries = [];
    _.forEach(roles, function (role) {
      isAdminQueries.push(queryForIsAdminCategory(role));
    });
    $q.all(isAdminQueries).then(function (data) {
      if (isAdminRole(data)) {
        return isAdminDeferred.resolve(true);
      }
      return isAdminDeferred.resolve(false);
    })["catch"](function () {
      isAdminDeferred.resolve(false);
    });
    return isAdminDeferred.promise;
  }
  function getUserPrivileges() {
    return restangular.one('user').one('authorities').get();
  }
  function getSelfData() {
    return restangular.one('user').get();
  }
  function retrieveUserList() {
    var requestParams = {
      pageLimit: -1,
      filter: 'isActive==true'
    };
    if (!App.userFactory.isSabre()) {
      requestParams.filter = 'isSabreEmployee!=true;isActive==true';
    }
    return restangular.one('users').get(requestParams);
  }
  function retrieveNonAdminUserList() {
    return restangular.one('users').one('nonadminusers').get();
  }
  function getUserWithoutDatabase() {
    return restangular.one('authenticateduser').get();
  }
  function loadUserList() {
    return retrieveUserList().then(function (data) {
      App.userList = _.map(_.get(data, 'users', []), function (user) {
        return new UserFactory(user);
      });
      return App.userList;
    });
  }
  function loadNonAdminUserList() {
    return retrieveNonAdminUserList().then(function (data) {
      App.nonAdminUserList = _.map(_.get(data, 'users', []), function (user) {
        return new UserFactory(user);
      });
    });
  }
  function addCookie() {
    return getUserWithoutDatabase().then(function (user) {
      if (!sessionStorage.getItem('carrierCode') && user.organization !== 'SG') {
        sessionStorage.setItem('carrierCode', user.organization);
      }
      return user;
    });
  }
  function refreshUserSettings() {
    var enabledApps = bootstrapFeaturesService.getEnabledApps();
    return $q.all(callLoadingDataFunctionsForEnabledApps(enabledApps, userConfigRefresh));
  }
  function loadSubsidiaryCarriers() {
    return restangular.one('configuration').one('subsidiaryCarriers').get().then(function (data) {
      App.subsidiaryCarriers = data.results;
    });
  }
  function loadVersion() {
    return restangular.one('version').get().then(function (data) {
      App.version = data;
    });
  }
  function retrieveCountryCodesData() {
    return restangular.one('ancillary').one('airport').one('country').one('codes').get().then(function (data) {
      App.airportCountryCodes = data.countryCodes;
    })["catch"](function () {
      App.airportCountryCodes = [];
    });
  }
  return {
    load: load,
    loadVersion: loadVersion,
    loadConfiguration: loadConfiguration,
    loadUser: loadUser,
    loadUserList: loadUserList,
    loadNonAdminUserList: loadNonAdminUserList,
    retrieveUserData: retrieveUserData,
    addCookie: addCookie,
    refreshUserSettings: refreshUserSettings
  };
};
BootstrapService.$inject = ['$q', 'BootstrapFeaturesService', 'StaticDataService', 'HepService', 'FOMarketsService', 'App', 'Restangular', 'UserFactory'];
module.exports = BootstrapService;